import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { cardCoverImageResource } from '@atlassian/jira-board-settings-card/src/services/card-cover-settings/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarNextGen from '@atlassian/jira-navigation-apps-sidebar-next-gen/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { projectSettingsSoftwareBoardsCardRoute } from '@atlassian/jira-router-routes-project-settings-product-routes-software-routes/src/projectSettingsSoftwareBoardsCardRoute.tsx';
import { softwareProjectLayoutNoOnboarding } from '@atlassian/jira-software-project-layout/src/index.tsx';
import { getSettingsNavigationResources } from './ui/project-settings/product-routes/common/index.tsx';
import Card, {
	LazyCard,
} from './ui/project-settings/product-routes/software/board-settings/card/index.tsx';

export const projectSettingsSoftwareBoardsCardRouteEntry = createEntry(
	projectSettingsSoftwareBoardsCardRoute,
	() => ({
		group: 'project-settings-software',
		ufoName: 'board-settings-apps.card-cover-settings-page.page.load',
		component: Card,
		layout: softwareProjectLayoutNoOnboarding,
		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarNextGen,
			sidebarId: SIDEBAR_ID.PROJECT_SETTINGS,
		},
		resources: [...getSettingsNavigationResources(), cardCoverImageResource],
		forPaint: [LazyAtlassianNavigation, LazyCard],
	}),
);
